import React from 'react'
import { getPMasterName } from '../util/commonInput'

export default class PMaster extends React.Component {
  render() {
    const { name, para } = this.props;
    return getPMasterName(name, para) || name || ""
  }
}